import { disclosureRank, maxDisclosureOf, navItemAllowed } from "./master";

export function collectBlockers(portfolio) {
  const rows = [];
  const push = (source, item) => {
    if (!item) return;
    rows.push({
      id: `${source}-${item.application}-${item.gate || item.title}`,
      app: item.application,
      severity: item.severity || "WARNING",
      title: item.title || item.severity,
      owner: item.pending_by,
      route: item.route || "/",
      item,
    });
  };
  (portfolio.approvals || []).forEach((item) => push("approval", item));
  (portfolio.actions || []).forEach((item) => push("action", item));
  (portfolio.waiting || []).forEach((item) => push("waiting", item));
  if (!rows.length) (portfolio.attention || []).forEach((item) => push("attention", item));
  return rows;
}

export function stageCounts(apps) {
  const counts = {};
  (apps || []).forEach((a) => {
    const key = a.stage || "Unknown";
    counts[key] = (counts[key] || 0) + 1;
  });
  return Object.entries(counts).sort((a, b) => b[1] - a[1]);
}

export function labelsForGuide(guide) {
  const exec = disclosureRank(maxDisclosureOf(guide)) <= 2;
  return {
    projects: exec ? "Applications in scope" : "Projects",
    blockers: exec ? "Items needing attention" : "Blockers",
    migration: exec ? "In active change" : "In migration",
    value: exec ? "Value progress" : "Value",
    sealed: exec ? "Decisions sealed" : "MDR sealed",
    awaiting: exec ? "Awaiting decision" : "Awaiting MDR",
    unknown: exec ? "Open questions (critical)" : "UNKNOWN-critical",
    gates: exec ? "Governance holds" : "Gates blocked",
    pipeline: exec ? "Where projects stand" : "Projects by stage",
    strategy: exec ? "Modernization mix" : "Strategy distribution",
    blockersTitle: exec ? "What needs a human next" : "Top blockers",
    health: exec ? "Programme health" : "Portfolio health",
  };
}

export function analyticsFlowsFor(guide) {
  const flows = [
    { id: "overview", label: "Overview" },
    { id: "actions", label: "Queue & blockers" },
    { id: "insights", label: "Pipeline & health" },
  ];
  if (disclosureRank(maxDisclosureOf(guide)) >= 2 && guide?.can_drill !== false) {
    flows[2] = { id: "insights", label: "Pipeline & 7R" };
  }
  return flows;
}

export function focusHref(focus) {
  return focus === "overview" ? "/" : `/?focus=${focus}`;
}

export function queueCount(portfolio) {
  return collectBlockers(portfolio).length
    || (portfolio?.approvals?.length || 0)
    + (portfolio?.actions?.length || 0)
    + (portfolio?.waiting?.length || 0)
    || (portfolio?.attention?.length || 0);
}

export function canOpenBlockerRoute(route, guide) {
  return navItemAllowed(route, guide);
}
